(() => {
  if (window.customReviewGalleryNavigationV1) return;
  window.customReviewGalleryNavigationV1 = true;
  const mount = () => {
    document.querySelectorAll('.jdgm-modal.jdgm-widget-revamp .jm-carousel, .jm-mfp-wrap.jdgm-gallery-popup .jm-mfp-content-wrapper').forEach((carousel) => {
      for (const direction of ['previous', 'next']) {
        if (carousel.querySelector('.custom-review-gallery-navigation-v1--' + direction)) continue;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-review-gallery-navigation-v1 custom-review-gallery-navigation-v1--' + direction;
        button.setAttribute('aria-label', direction === 'previous' ? 'Previous review photo' : 'Next review photo');
        button.innerHTML = '<svg viewBox="0 0 24 40" aria-hidden="true"><path d="' + (direction === 'previous' ? 'M19 5 L5 20 L19 35' : 'M5 5 L19 20 L5 35') + '" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        carousel.append(button);
      }
    });
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; mount(); });
  }).observe(document.body, { childList: true, subtree: true });
  mount();
  let lastCard = null;
  let recoveryTimer = null;
  document.addEventListener('click', (event) => {
    const card = event.target.closest('.jdgm-media-card[data-review-id]');
    if (card) lastCard = card;
    const arrow = event.target.closest('.custom-review-gallery-navigation-v1');
    const legacy = arrow?.closest('.jm-mfp-wrap.jdgm-gallery-popup');
    if (legacy) {
      const items = [...legacy.querySelectorAll('.jm-mfp-carousel .jdgm-gallery__thumbnail-link')];
      const source = legacy.querySelector('.jm-mfp-img')?.src;
      const path = (url) => { try { return new URL(url, location.origin).pathname; } catch { return null; } };
      const selected = items.findIndex((item) => path(item.querySelector('[data-mfp-src]')?.dataset.mfpSrc) === path(source));
      if (selected < 0 || items.length < 2) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const previous = arrow.matches('.custom-review-gallery-navigation-v1--previous');
      items[(selected + (previous ? -1 : 1) + items.length) % items.length].click();
      return;
    }
    const modal = arrow?.closest('.jdgm-modal.jdgm-widget-revamp');
    if (!modal) return;
    const thumbnails = [...modal.querySelectorAll('.jm-thumbnails .jm-media-grid__item')];
    const selected = thumbnails.findIndex((item) => item.getAttribute('aria-pressed') === 'true');
    const previous = arrow.matches('.custom-review-gallery-navigation-v1--previous');
    if (selected < 0) return;
    if ((!previous && selected < thumbnails.length - 1) || (previous && selected > 0)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      thumbnails[selected + (previous ? -1 : 1)].click();
      return;
    }
    const reviewId = modal.querySelector('[review-uuid]')?.getAttribute('review-uuid');
    const widget = lastCard?.closest('.jdgm-cards-carousel');
    if (!widget || !widget.contains(lastCard) || lastCard.dataset.reviewId !== reviewId) return;
    const seen = new Set();
    const cards = [...widget.querySelectorAll('.jdgm-media-card[data-review-id]')].filter((item) => {
      if (item.matches('.jdgm-clone-before, .jdgm-clone-after') || seen.has(item.dataset.reviewId)
        || !item.querySelector('img[src*="review-images.judgeme.com"]')) return false;
      seen.add(item.dataset.reviewId);
      return true;
    });
    const index = cards.findIndex((item) => item.dataset.reviewId === reviewId);
    if (index < 0 || cards.length < 2) return;
    const next = cards[(index + (previous ? -1 : 1) + cards.length) % cards.length];
    const close = modal.querySelector('.jm-indicator__close');
    if (!close) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clearTimeout(recoveryTimer);
    close.click();
    next.click();
    // Opening through the app keeps the photo, reviewer and review text together.
    // Reverse navigation lands on the preceding review's final photo.
    {
      let attempts = 0;
      const selectLast = () => {
        const opened = document.querySelector('.jdgm-modal.jdgm-widget-revamp');
        if (!opened) return;
        if (opened.querySelector('[review-uuid]')?.getAttribute('review-uuid') === next.dataset.reviewId) {
          const items = opened.querySelectorAll('.jm-thumbnails .jm-media-grid__item');
          items[previous ? items.length - 1 : 0]?.click();
          return;
        }
        if (++attempts < 15) recoveryTimer = setTimeout(selectLast, 100);
      };
      recoveryTimer = setTimeout(selectLast, 100);
    }
  }, true);
})();
